import { Photo } from 'src/admin/listing-editor/components/PhotosPanel/types';
import { MINIMUM_PHOTOS } from 'src/admin/listing-editor/constants';

export const validatePhotosCount = (photoCount: number): boolean => (
  photoCount >= MINIMUM_PHOTOS
);

export const validatePhotosPending = (photos: Photo[]): boolean => (
  !(photos == null || photos?.some((photo) => photo.status === 'pending'))
);
